import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * WP-PT — Notifications are DEFERRED for App Alpha. The former prototype
 * Notification Center was browser-local and is no longer part of the product
 * surface. The historical URL redirects to the app home so a stale link is
 * never a dead end and never shows prototype behavior.
 */
export const Route = createFileRoute("/app/notifications")({
  beforeLoad: () => {
    throw redirect({ to: "/app", replace: true });
  },
});
